module.exports = __webpack_public_path__ + "img/other1.1175525f.jpg";